<template>
  <v-container id="logs-email-dialog">
    <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
    //-->

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.mobile"
      no-click-animation
      :overlay-opacity="0.7"
      persistent
    >
      <v-card
        max-height="900px"
        class="backdrop dialog-card"
        id="swal_log_email_dialog"
      >
        <v-overlay absolute :value="overlay_loading">
          <v-progress-circular
            indeterminate
            :size="80"
            :width="7"
            color="secondary"
          ></v-progress-circular>
        </v-overlay>
        <v-card-title class="backdrop lighten-1 dialog-title">
          <span class="text-h5">Email Log(s)</span>
        </v-card-title>
        <v-card-text class="backdrop pa-0 white--text">
          <v-container class>
            <v-form v-model="validForm" ref="form">
              <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox
                      :rules="[field_rules.requiredCombo]"
                      v-model="email_form.to"
                      :items="matchingEmails"
                      :search-input.sync="searchInput"
                      label="To*"
                      hint="Type in a new email address, or select one"
                      persistent-hint
                      hide-selected
                      multiple
                      small-chips
                      enterkeyhint="Enter"
                    >
                      <template v-slot:no-data>
                        <v-list-item
                          @click="addSearchInputToList(searchInput)"
                          class="text-wrap"
                        >
                          <v-list-item-content class="text-wrap">
                            <v-list-item-title class="text-wrap">
                              Press <kbd>enter</kbd> or click this to add the
                              email address : "<strong>{{ searchInput }}</strong
                              >"
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                      <template
                        v-slot:selection="{ attrs, item, parent, selected }"
                      >
                        <v-chip
                          @click="parent.selectItem(item)"
                          v-if="item === item"
                          v-bind="attrs"
                          :input-value="selected"
                          label
                          small
                          dark
                          :color="VerifyEmailFormatColor(item)"
                          :text-color="VerifyEmailFormatTextColor(item)"
                        >
                          <span class="pr-2">
                            {{ item }}
                          </span>
                          <v-icon small> $delete </v-icon>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="email_form_subject"
                      v-model="email_form.subject"
                      label="Subject*"
                      :rules="[field_rules.required]"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-textarea v-model="email_form.body" label="Body" outlined>
                    </v-textarea>
                    <div>
                      The email body will contain the following appended :
                      <strong style="display: inline">
                        Please review the following RPD EverWatch content
                        <a> here </a>
                      </strong>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-container>
        </v-card-text>

        <!--Dialog Buttons-->
        <v-card-actions class="backdrop lighten-1 border-card">
          <v-spacer></v-spacer>

          <v-btn color="secondary" class="black--text" @click="priorToClose">
            Close
          </v-btn>
          <v-btn
            color="secondary"
            class="black--text"
            :disabled="!validForm"
            @click="priorToSendEmail"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../../scss/site.scss";

.dialog-card {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.dialog-title {
  margin-bottom: 2px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
}

.custom-divider {
  height: 2px;
  background-color: black;
}

.border-card {
  margin: 2px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../../mixins/bus_common";
import tiptap from ".././tiptap.vue";
export default {
  name: "logs-email-dialog",
  mixins: [bus_common],
  props: {
    logEntryIDs: Array,
  },
  components: { tiptap },
  data() {
    return {
      dialog: true,
      overlay_loading: false,
      validForm: false,
      field_rules: {
        required: (value) => !!value || "This field is required",
        requiredCombo: (v) => v.length >= 1 || "At least one email is required",
        min: (v) => v.length >= 8 || "Min 8 characters",
        max25: (v) => v.length <= 60 || "Max 60 characters",
      },
      editorLimit: 3999,
      swal_target: "swal_log_email_dialog",
      email_form: {
        to: [],
        subject: "RPD EverWatch Log",
        body: "",
      },
      matchingEmails: [],
      searchInput: null,
      EmailURL:
        "https://rpdportal.org/?returnURL=https://rpdwatch.org/logs/search?logEntries=",
    };
  },
  methods: {
    priorToClose() {
      let callback = () => {
        this.closeDialog();
      };
      this.swall_diag(
        "Close?",
        "Are you sure you would like to close this dialog? Any unsent changes will be lost.",
        "question",
        callback,
        "Yes",
        "No",
        null,
        this.swal_target
      );
    },

    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$emit("closeDialog");
      }, 300);
    },

    priorToSendEmail() {
      if (this.validateEmailForm()) {
        let callback = () => {
          this.sendEmail();
        };
        this.swall_diag(
          "Email Log(s)?",
          `Are you sure you would like to email these ${this.logEntryIDs.length} log(s) ?`,
          "question",
          callback,
          "Yes",
          "No",
          null,
          this.swal_target
        );
      }
    },
    validateEmailForm() {
      // Before sending, we should double check each email is valid
      for (let i = 0; i < this.email_form.to.length; i++) {
        const email = this.email_form.to[i];
        if (this.isValidEmail(email) == false) {
          let msg =
            "One or more of your entered emails are in an invalid format. Please correct them and try again. ";
          this.swall_it("Error!", msg, "error", null, null, this.swal_target);
          return false;
        }
      }

      return true;
    },
    async sendEmail() {
      let callback = () => {
        this.closeDialog();
      };

      var form = {
        token: this.$store.state.user.token,
        logEntryIDs: this.logEntryIDs,
        to: this.email_form.to,
        body: this.email_form.body,
        subject: this.email_form.subject,
      };

      this.overlay_loading = true;
      await this.$axios
        .post("/api/logs/EmailLogs", form)
        .then((response) => {
          this.swall_it(
            "Email Sent!",
            "The email was successfully sent.",
            "success",
            callback,
            null,
            this.swal_target
          );
          this.overlay_loading = false;
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
          this.overlay_loading = false;
        });
    },
    VerifyEmailFormatColor(item) {
      if (this.isValidEmail(item)) return "secondary";
      else return "red";
    },
    VerifyEmailFormatTextColor(item) {
      if (this.isValidEmail(item)) return "black";
      else return "white";
    },
    isValidEmail(email) {
      // Regular expression for a basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    async init() {
      this.overlay_loading = true;
      this.recordLogData();
      this.generateLogURL();
      this.getEmailListings();
      this.overlay_loading = false;
    },
    arrayToStringWithCommas(numbers) {
      // Use the join method to concatenate array elements with commas
      return numbers.join(", ");
    },
    generateLogURL() {
      this.EmailURL =
        this.EmailURL + this.arrayToStringWithCommas(this.logEntryIDs);
    },
    addSearchInputToList(search) {
      if (search != null) {
        this.email_form.to.push(search);
        this.searchInput = "";
      }
    },
    async recordLogData() {
      var form = {
        token: this.$store.state.user.token,
        logEntryIDs: this.logEntryIDs,
        operation: "Email Generated",
      };
      await this.$axios
        .post("/api/logs/RecordLogs", form)
        .then((response) => {})
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
        });
    },

    async getEmailListings() {
      var form = {
        token: this.$store.state.user.token,
      };
      await this.$axios
        .post("/api/emails/listings", form)
        .then((response) => {
          this.matchingEmails = response.data;
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
        });
    },
  },
  watch: {},

  computed: {},

  mounted() {
    this.init();
  },
};
</script>
